import { Button, ButtonLink, LocalizedError, Stack, Typography } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { ApiDigitalWalletToken } from '../../../openapi';
import { useDigitalWalletTokenResolveMutation } from '../../../api/digital-wallet-tokens';

export function DigitalWalletTokenActions({ token }: { token: ApiDigitalWalletToken }) {
  const { t } = useTranslation();

  const { error, isPending, variables, mutate } = useDigitalWalletTokenResolveMutation({
    tokenId: token.id,
  });

  const isProvisioning =
    token.state === 'PROVISIONING' || (isPending && variables?.action === 'provision');
  const isTerminating = isPending && variables?.action === 'terminate';

  const handleTerminate = () => {
    if (!isPending && token.state === 'PENDING') {
      mutate({ action: 'terminate' });
    }
  };

  const handleProvision = () => {
    if (!isPending && token.state === 'PENDING') {
      mutate({ action: 'provision' });
    }
  };

  const isFinal = !(token.state === 'PENDING' || isProvisioning || isTerminating);

  return isFinal ? (
    <ButtonLink to="/account/home" size="large" fullWidth>
      {t('Go Home')}
    </ButtonLink>
  ) : (
    <>
      {error ? (
        <Typography variant="body2" color="error">
          <LocalizedError error={error} />
        </Typography>
      ) : null}

      <Stack direction={{ xs: 'column-reverse', sm: 'row' }} spacing={2} width="100%">
        <Button
          size="large"
          color="secondary"
          disabled={isProvisioning}
          loading={isTerminating}
          onClick={handleTerminate}
          fullWidth
        >
          {t('Decline')}
        </Button>
        <Button
          size="large"
          color="primary"
          disabled={isTerminating}
          loading={isProvisioning}
          onClick={handleProvision}
          fullWidth
        >
          {t('Confirm')}
        </Button>
      </Stack>
    </>
  );
}
